module.exports = __webpack_public_path__ + "static/media/list.2b65b679.svg";